import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import CompanyInformation from './CompanyInformation';
import FinancialRisk from './FinancialRisk';
import People from './People';
import GroupStructure from './GroupStructure';
import Records from './Records';
import RiskFactors from './RiskFactors';
import './styles.less';

const Summary = ({ summary, records, companyInfo }) => {
  return (
    <section className="kyb-company-summary kyb-company-summary-main">
      <Row>
        <Col span={24}>
          <CompanyInformation summary={summary} />
        </Col>
      </Row>
      <div className="kyb-company-summary-grid kyb-company-summary-grid-1-3">
        <div>
          <FinancialRisk summary={summary} />
        </div>
        <div>
          <RiskFactors companyInfo={companyInfo} />
        </div>
      </div>
      <div className="kyb-company-summary-grid kyb-company-summary-grid-1-1">
        <div>
          <People summary={summary} />
        </div>
        <div>
          <GroupStructure summary={summary} />
        </div>
      </div>
      <Row>
        <Col span={24}>
          <Records records={records} recordsToShow={2} />
        </Col>
      </Row>
    </section>
  );
};

Summary.propTypes = {
  summary: PropTypes.object.isRequired,
  records: PropTypes.object.isRequired,
  companyInfo: PropTypes.object.isRequired,
};

export default Summary;
